export default __webpack_public_path__ + "media/images/celeste_setting-41991e015706378928c6f5c430d21a19.png";